import * as React from 'react';

//hook
import { useState, useEffect } from 'react';
import { UserConsumer } from '../hooks/context/UserContext';
import { useApi } from '../hooks/useApi';

//component
import CompletedClientField from '../component/roleForm/CompletedClientField';
import CompletedDriverField from '../component/roleForm/CompletedDriverField';
import CompletedHostField from '../component/roleForm/CompletedHostField';

//translate
import { useTranslation } from 'react-i18next';

//api
import { GetRoletProfileApi } from '../api/completedRole/GetRoletProfileApi';

//type
import { clientProfileType, driverProfileType, hostProfileType } from '../api/completedRole/type/CompletedRoleType';

//mui
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import ReplayIcon from '@mui/icons-material/Replay';




interface completeRoleProps {
    openCompletedProfile: boolean
    setOpenCompletedProfile:(open:boolean)=>void
    themeRole: string,
    setThemeRole: (themeRole: string) => void
}
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CompletedRole = ({openCompletedProfile, setOpenCompletedProfile, themeRole, setThemeRole}:completeRoleProps) => {
    const { t } = useTranslation();
    let {userData,setTheme} = UserConsumer()
    const [RoleLicenseFront, setRoleLicenseFront] = useState<string>("");
    const [RoleLicenseBack, setRoleLicenseBack] = useState<string>("");
    const [driverPichture, setDriverPichture] = useState<string>("");
    const [hostCommercialRegistry, setHostCommercialRegistry] = useState<string>("");
    const [clientProfile, setClientProfile] = useState<clientProfileType>(
        {
            id: 0, 
            front_image_url: null,
            background_image_url: null,
            license_number: '', 
            billing_address: '', 
        })
    const [driverProfile, setDriverProfile] = useState<driverProfileType>(
        {
            id: 0,
            picture_url: null,
            hourly_desired_wage: 0,
            extra_hour_price: 0,
            preferred_start_time:null,
            preferred_end_time:null,
            front_license_image_url: null,
            background_license_image_url: null
        })
    const [hostProfile, setHostProfile] = useState<hostProfileType>(
        {
            id:0,
            user_id:0,
            is_company:0,
            company_name:"",
            commercial_registry:null,
            is_confirmed:false,
        })

    const {
        loading: getCompletedRoleLoading,
        error: getCompletedRoleError,
        HandlerApi: getCompletedRoleApi
    } = useApi(GetRoletProfileApi, "GET");

    //get the data if the user is completed
    useEffect(() => {
        const RoleProfile = async ()=>{
            if (openCompletedProfile) {
                if (themeRole === "client" && userData?.is_client) {
                    const result = await getCompletedRoleApi(themeRole)
                    setClientProfile(result.data)
                }
                else if (themeRole === "driver" && userData?.is_driver) {
                    const result = await getCompletedRoleApi(themeRole)
                    setDriverProfile(result.data)
                }
                else if (themeRole === "host" && userData?.is_host) {
                    const result = await getCompletedRoleApi(themeRole)
                    setHostProfile(result.data)
                }
                else {
                    return null
                }
            }
        }
        RoleProfile()
    }, [openCompletedProfile]);

    const handleCloseDilaog = () => {
        setOpenCompletedProfile(false)
        setRoleLicenseFront('')
        setRoleLicenseBack('')
        setDriverPichture('')
        setHostCommercialRegistry('')
        setClientProfile({    
            id: 0,
            billing_address: "",
            license_number: "",
            front_image_url: null,
            background_image_url: null,
        })
        setDriverProfile({
            id: 0,
            picture_url: null,
            hourly_desired_wage: 0,
            extra_hour_price: 0,
            preferred_start_time:null,
            preferred_end_time:null,
            front_license_image_url: null,
            background_license_image_url: null
        })
        setHostProfile({   
            id:0,
            user_id:0,
            is_company:0,
            company_name:"",
            commercial_registry:null,
            is_confirmed:false,
        })
    }
    return (
        <div>
            <Dialog 
            open={openCompletedProfile}
            onClose={handleCloseDilaog}
            slots={{
            transition: Transition,
            }}
            disableRestoreFocus
            maxWidth="sm"
            fullWidth 
            >
                <DialogTitle className='flex gap-3'>
                <p>{t(`complete_profile_as_a_${themeRole}`)}</p>
                </DialogTitle>
                <DialogContent>
                    {
                    userData?.is_client || userData?.is_host || userData?.is_driver 
                    ? 
                    (
                        getCompletedRoleLoading 
                        ?
                        (
                        <Box sx={{ display: 'flex', justifyContent: "center"}}>
                            <CircularProgress />
                        </Box>
                        )
                        : getCompletedRoleError ?
                        (
                        <div className='cursor-pointer flex justify-center w-full'>
                        <ReplayIcon onClick={()=> getCompletedRoleApi(themeRole)} className='!text-[40px]' />
                        </div>
                        )
                        :
                        (
                        themeRole === "client"
                        ?                    
                        <CompletedClientField 
                        setOpenCompletedProfile={setOpenCompletedProfile}
                        RoleLicenseFront={RoleLicenseFront}
                        setRoleLicenseFront={setRoleLicenseFront}
                        RoleLicenseBack={RoleLicenseBack}
                        setRoleLicenseBack={setRoleLicenseBack}
                        clientProfile={clientProfile} 
                        setClientProfile={setClientProfile}
                        themeRole={themeRole}
                        />
                        : themeRole === "driver"
                        ?
                        <CompletedDriverField 
                        setOpenCompletedProfile={setOpenCompletedProfile}
                        RoleLicenseFront={RoleLicenseFront}
                        setRoleLicenseFront={setRoleLicenseFront}
                        RoleLicenseBack={RoleLicenseBack}
                        setRoleLicenseBack={setRoleLicenseBack}
                        driverProfile={driverProfile} 
                        setDriverProfile={setDriverProfile}
                        driverPichture={driverPichture}
                        setDriverPichture={setDriverPichture}
                        themeRole={themeRole}
                        />
                        :
                        <CompletedHostField 
                        setOpenCompletedProfile={setOpenCompletedProfile}
                        hostProfile={hostProfile}
                        setHostProfile={setHostProfile}
                        hostCommercialRegistry={hostCommercialRegistry}
                        setHostCommercialRegistry={setHostCommercialRegistry}
                        themeRole={themeRole}
                        />
                        )
                    )
                    :
                    (
                        themeRole === "client"
                        ?                    
                        <CompletedClientField 
                        setOpenCompletedProfile={setOpenCompletedProfile}
                        RoleLicenseFront={RoleLicenseFront}
                        setRoleLicenseFront={setRoleLicenseFront}
                        RoleLicenseBack={RoleLicenseBack}
                        setRoleLicenseBack={setRoleLicenseBack}
                        clientProfile={clientProfile} 
                        setClientProfile={setClientProfile}
                        themeRole={themeRole}
                        />
                        : themeRole === "driver"
                        ?
                        <CompletedDriverField 
                        setOpenCompletedProfile={setOpenCompletedProfile}
                        RoleLicenseFront={RoleLicenseFront}
                        setRoleLicenseFront={setRoleLicenseFront}
                        RoleLicenseBack={RoleLicenseBack}
                        setRoleLicenseBack={setRoleLicenseBack}
                        driverProfile={driverProfile} 
                        setDriverProfile={setDriverProfile}
                        driverPichture={driverPichture}
                        setDriverPichture={setDriverPichture}
                        themeRole={themeRole}
                        />
                        :
                        <CompletedHostField 
                        setOpenCompletedProfile={setOpenCompletedProfile}
                        hostProfile={hostProfile}
                        setHostProfile={setHostProfile}
                        hostCommercialRegistry={hostCommercialRegistry}
                        setHostCommercialRegistry={setHostCommercialRegistry}
                        themeRole={themeRole}
                        />
                    )
                    }
                </DialogContent>
            </Dialog>
        </div>
    )
}

export default CompletedRole